import React from 'react';

import { useIntl } from 'react-intl';
import Measure from 'react-measure';

import useLocation from 'hooks/location/use-location';
import { useAppHeaderDimensions } from 'hooks/use-app-header-dimensions';
import useMediaQuery from 'hooks/use-media-query';
import { useOrderContext } from 'state/order';
import { getAllLocalizedVersionsOfRoute, routes } from 'utils/routing';

import DesktopHeader from './desktop-header';
import MobileHeader from './mobile-header';
import SignupMobileHeader from './signup-mobile-header';

export const routesWithoutHeader = [
  routes.cart,
  ...getAllLocalizedVersionsOfRoute('hockeyChallenge'),
];

const AppHeader: React.FC = () => {
  const { serviceMode, cateringPickupDateTime, deliveryAddress } = useOrderContext();
  const isMobile = useMediaQuery('mobile');
  const { formatMessage } = useIntl();
  const { updateAppHeaderDimensions } = useAppHeaderDimensions();

  const {
    location: { pathname },
  } = useLocation();

  if (routesWithoutHeader.includes(pathname)) {
    return null;
  }
  const shouldShowSignupMobileHeader =
    pathname === formatMessage({ id: 'routes.signUp' }) ||
    pathname === formatMessage({ id: 'routes.signIn' }) ||
    pathname === routes.confirmOtp;

  return (
    <Measure
      onResize={contentRect => {
        if (contentRect.entry) {
          updateAppHeaderDimensions({
            top: contentRect.entry.top,
            left: contentRect.entry.left,
            width: contentRect.entry.width,
            height: contentRect.entry.height,
          });
        }
      }}
    >
      {({ measureRef }) => {
        if (shouldShowSignupMobileHeader) {
          return <SignupMobileHeader ref={measureRef} />;
        }

        if (isMobile) {
          return (
            <MobileHeader
              ref={measureRef}
              serviceMode={serviceMode}
              userAddress={deliveryAddress?.addressLine1}
              cateringPickupDateTime={cateringPickupDateTime}
            />
          );
        }

        return (
          <DesktopHeader
            ref={measureRef}
            serviceMode={serviceMode}
            userAddress={deliveryAddress?.addressLine1}
            cateringPickupDateTime={cateringPickupDateTime}
          />
        );
      }}
    </Measure>
  );
};

export default AppHeader;
export { default as LogoHeader } from './logo-header';
export { default as MenuHeader, HEADER_HEIGHT } from './menu-header';
